import React from "react";

const Disclaimer = () => (
  <div className="legal-disclaimer">
    This system is for the use of authorized users only. Individuals using this
    computer system without authority, or in excess of their authority, are
    subject to having all of their activities on this system monitored and
    recorded by systems personnel. In the course of monitoring individuals
    improperly using this system, or in the course of system maintenance, the
    activities of authorized users may also be monitored. By proceeding, you
    acknowledge and consent to such monitoring and understand that unauthorized
    use of this system may result in disciplinary action and/or legal
    prosecution.
  </div>
);

export default Disclaimer;
